import React from 'react'
import { useHistory } from 'react-router-dom'
import ReactGA from 'react-ga'
import _ from 'lodash'
import { PET_TYPE_ICON, GENDER_ICON, NOT_FOUND_INFO } from './constants'
import { PET_GENDERS } from '../../../../utils/constants'
import { formatCpf, formatDate } from '../../../../utils/formatters'
import { getTypeLabel } from '@cobasi/cobasi-utils/helpers/pet'
import { ReactComponent as User } from '../../../../assets/icons/user-transparent-alt.svg'
import { ReactComponent as ChevronRight } from '../../../../assets/icons/chevron-right.svg'
import { ReactComponent as Stethoscope } from '../../../../assets/icons/stethoscope-all-gray.svg'
import Card from '../../../../components/Card'
import * as S from './styles'
import { SHORTCUT_PARAM } from '../../TutorsAndPets/constants'

const ResultBox = ({ resultFor = 'tutors', data = [], loading = false, limit, currentPage, totalResults, showItemsCount = true }) => {
  const start = (currentPage - 1) * limit
  const end = start + limit
  const history = useHistory()

  const queryParams = new URLSearchParams(window.location.search)
  const shortcut = queryParams.get(SHORTCUT_PARAM)
  const isNewAppointmentShortCut = shortcut !== null

  const goToPage = (url) => {
    history.push(`/${url}`)
    ReactGA.pageview(`/${url}`)
  }

  const petNavigationUrl = (petId) => {
    return isNewAppointmentShortCut ? `vets/prontuario?petId=${petId}&nova_consulta=true` : `vets/detalhes-do-pet/${petId}`
  }

  const renderResults = () => {
    if (resultFor === 'tutors') { return }
    return (showItemsCount && totalResults > 0) && <S.BoxResult>{`${totalResults} ${totalResults > 1 ? 'resultados encontrados' : 'resultado encontrado'}`}</S.BoxResult>
  }

  const renderTutors = () => {
    const tutorDataOrder = _.orderBy(data, [
      (item) => `${item.firstName || ''} ${item.lastName || ''}`.toLowerCase(),
      (item) => (item.email || '').toLowerCase()
    ])

    const renderByRange = (data) => data.map((tutor, index) => {
      return <Card full key={`${tutor.name}-${index}`}>
        <S.BoxUser onClick={() => goToPage(`vets/detalhes-do-tutor/${tutor?.id}${window.location.search}`)}>
          <S.Image><User /></S.Image>
          <S.BoxInfoUser>
            <S.User>{`${tutor.firstName ?? ''} ${tutor.lastName ?? ''}`}</S.User>
            <S.CPF>CPF: {tutor.document ? formatCpf(tutor.document) : NOT_FOUND_INFO}</S.CPF>
          </S.BoxInfoUser>
          <S.BoxEmail>
            <S.Email>{tutor.email ?? NOT_FOUND_INFO}</S.Email>
            <S.Button>
              <ChevronRight />
            </S.Button>
          </S.BoxEmail>
        </S.BoxUser>
      </Card>
    })

    return <>
      { renderByRange(tutorDataOrder) }
    </>
  }

  const renderPets = () => {
    return <>
      { data.map((pet, index) => {
        return <Card full key={`${pet.name}-${index}`}>
          <S.BoxPet onClick={() => goToPage(petNavigationUrl(pet.id))}>
            <S.Image>{PET_TYPE_ICON[pet?.breed?.type || 'DEFAULT']}</S.Image>
            <S.BoxInfoPet>
              <S.Pet>{pet.name}, {pet?.breed?.name || NOT_FOUND_INFO}</S.Pet>
              <S.Tutor>Tutor: {pet.ownerName || NOT_FOUND_INFO}</S.Tutor>
            </S.BoxInfoPet>
            <S.BoxTags>
              <S.PrimaryTags>{pet?.breed?.type ? getTypeLabel(pet.breed.type) : NOT_FOUND_INFO}</S.PrimaryTags>
              <S.SecondaryTag>{GENDER_ICON[pet.gender]} {PET_GENDERS[pet.gender] || NOT_FOUND_INFO}</S.SecondaryTag>
              <S.Button>
                <ChevronRight />
              </S.Button>
            </S.BoxTags>
          </S.BoxPet>
        </Card>
      })
      }
    </>
  }

  const renderAppointments = () => {
    return <>
      { data.map((appointment, index) => {
        return <Card full key={index} loading={loading} skeletonHeight={76}>
          <S.BoxAppointment onClick={() => goToPage(`vets/prontuario?appointmentId=${appointment?.id}`)}>
            <S.Image><Stethoscope /></S.Image>
            <S.BoxInfoAppointment>
              <S.Appointment>{formatDate({ date: appointment?.date, format: 'DD/MM/YYYY' })}</S.Appointment>
              <S.Tutor>Consulta criada por: <strong>{appointment?.professional.name}</strong></S.Tutor>
            </S.BoxInfoAppointment>
            <S.BoxTags>
              <S.Button>
                <ChevronRight />
              </S.Button>
            </S.BoxTags>
          </S.BoxAppointment>
        </Card>
      })
      }
    </>
  }

  const cardsToRender = () => {
    const resourcesToRender = resultFor.charAt(0).toUpperCase() + resultFor.slice(1)

    return (
      loading
        ? Array(8).fill().map((_, index) => <Card key={'data-item-' + index} full loading skeletonHeight={76} />)
        : totalResults === 0
          ? <></>
          : eval(`render${resourcesToRender}()`)
    )
  }

  return (
    <S.CardsGroup>
      {renderResults()}
      {cardsToRender()}
    </S.CardsGroup>
  )
}

export default ResultBox
